import { FilterValues } from "components/filters/FilterContext";
import { mapAppointmentTypeFilterToInstruction, mapAppointPhaseFilterToInstruction, mapArtistFilterToInstruction, mapProductionFilterToInstruction, mapResponseToAppointmentPhaseFilter, mapResponseToAppointmentTypeFilter, mapResponseToArtistFilter, mapResponseToProductionFilter, mapResponseToMonthFilter, mapMonthFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstructionExternal = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
): server.dto.PlanningByMonthQuery => ({
  artistIds: mapArtistFilterToInstruction(filter.artist),
  productionIds: mapProductionFilterToInstruction(filter.production),
  phases: mapAppointPhaseFilterToInstruction(filter.appointmentPhase),
  appointmentTypes: mapAppointmentTypeFilterToInstruction(filter.appointmentType),
  date: mapMonthFilterToInstruction(filter.month),
  cache: filterSet
});

export const mapResponseToFilterValuesExternal = (
  response: server.dto.PlanningByMonthFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  artist: mapResponseToArtistFilter(response.artists),
  production: mapResponseToProductionFilter(response.productions),
  appointmentPhase: mapResponseToAppointmentPhaseFilter(response.phases),
  appointmentType: mapResponseToAppointmentTypeFilter(response.appointmentTypes),
  month: mapResponseToMonthFilter(response.date),
});
